<template>
  <i :class="iconName"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    iconName: {
      type: String
    }
  }
}
</script>

<style lang="scss">
i[class*="rhg-font-icon--"] {
  background-size: contain;
  width: 24px;
  height: 24px;
  font-size: 24px;
  display: block;
  position: relative;
  margin: 0;
}
</style>
